import Loader from '@/components/Includes/Loader/Loader.vue';
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import ICity from '@/interfaces/cities/ICity';
import IPayloadQuery from "@/interfaces/IPayloadQuery";
import searchByTable from '@/libs/searchQuery/searchByTable';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import CityTools from './CityListTools/CityListTools.vue';

@Component({
    name: 'CitiesList',
    components: {
        CityTools,
        TableEmpty,
        Loader
    }
})
export default class CitiesList extends Vue {
    @Action private citiesList!: (query: IPayloadQuery) => Promise<void>;

    @Getter private getCities!: () => ICity[];

    private loading: boolean = true;

    private cities: ICity[] = [];

    private filtered: ICity[] | object[] | null = null;

    private columns: string[] = [
        'id',
        'name',
        'heartbeatName'
    ];

    private get citiesData() {
        return this.filtered ? this.filtered : this.cities;
    }

    private get notEmpty() {
        return this.cities.length !== 0;
    }

    private cityDetail(city: any) {
        this.$router.push({
            name: 'city_detail',
            params: { id: city.id, cityData: city }
        });
    }

    private filterData(query: string) {
        this.filtered = searchByTable(query, this.cities)
    }

    private async mounted() {
        try {
            
            await this.citiesList({ query: '?pagination=false' });
            this.cities = this.getCities();

            this.loading = false;
        } catch {
            return void 0;
        }
    }
};


